import { createContext } from 'react'

const AppDataContext = createContext()
const AppDataDispatchContext = createContext()

export { AppDataContext, AppDataDispatchContext }
